import { jsx as _jsx } from "react/jsx-runtime";
export function Icon(props) {
    if (props.animated) {
        const { icon: AnimatedComponent, label, size = 16, className } = props;
        return (_jsx("span", { "aria-label": label, role: "img", className: className, children: _jsx(AnimatedComponent, { size: size }) }));
    }
    const { icon: LucideIconComponent, label, size = 16, className, animated: _animated, ...rest } = props;
    return (_jsx(LucideIconComponent, { "aria-label": label, role: "img", size: size, className: className, ...rest }));
}
//# sourceMappingURL=Icon.js.map